(function() {
  var merge,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  merge = require('node_modules/turf-merge');

  L.Control.MfDraw = (function(superClass) {
    extend(MfDraw, superClass);

    function MfDraw() {
      this.addPolygon = bind(this.addPolygon, this);
      this._getCurrentAsGeojson = bind(this._getCurrentAsGeojson, this);
      this._polySelected = bind(this._polySelected, this);
      this._selectPressed = bind(this._selectPressed, this);
      this._drawCircle = bind(this._drawCircle, this);
      this._drawPolygon = bind(this._drawPolygon, this);
      this._drawRectangle = bind(this._drawRectangle, this);
      this._additiveButtonPressed = bind(this._additiveButtonPressed, this);
      this._subtractiveButtonPressed = bind(this._subtractiveButtonPressed, this);
      this._pgis = bind(this._pgis, this);
      this._getPgisParams = bind(this._getPgisParams, this);
      this._setPgisParams = bind(this._setPgisParams, this);
      this._mergeNewShape = bind(this._mergeNewShape, this);
      this.addGeometryToLayer = bind(this.addGeometryToLayer, this);
      this._finishDrawing = bind(this._finishDrawing, this);
      this._handleDrawComplete = bind(this._handleDrawComplete, this);
      this._setReenable = bind(this._setReenable, this);
      this._anyButtonPressed = bind(this._anyButtonPressed, this);
      this._undoPressed = bind(this._undoPressed, this);
      this.setLayer = bind(this.setLayer, this);
      this.removeTransform = bind(this.removeTransform, this);
      this.addTransform = bind(this.addTransform, this);
      this.onRemove = bind(this.onRemove, this);
      this.deleteZone = bind(this.deleteZone, this);
      this.setDefaults = bind(this.setDefaults, this);
      this.setFinishedStyle = bind(this.setFinishedStyle, this);
      this.setStyle = bind(this.setStyle, this);
      MfDraw.__super__.constructor.call(this);
      this.setDefaults();
      L.drawLocal.draw.handlers.rectangle.tooltip.start = 'Click or drag to draw rectangle';
      L.drawLocal.draw.handlers.circle.tooltip.start = 'Click or drag to draw circle';
    }

    MfDraw.prototype.setStyle = function() {
      return this.fire('zone:style');
    };

    MfDraw.prototype.setFinishedStyle = function(opacity, weight, color) {
      if (weight == null) {
        weight = 2;
      }
      if (color == null) {
        color = '#0F0';
      }
      return this.options.finished.style = {
        'fillOpacity': opacity,
        'weight': weight,
        'color': color
      };
    };

    MfDraw.prototype.setDefaults = function() {
      return this.options = {
        position: 'topleft',
        draw: {
          style: {
            color: '#008161',
            width: 3
          }
        },
        finished: {
          style: {
            'fillOpacity': 0.6,
            'weight': 2,
            'color': '#0F0'
          }
        },
        colors: {
          style: (function(_this) {
            return function(mode) {
              if (_this.mode === 'add') {
                return {
                  color: '#008000',
                  width: 3,
                  icon: {
                    iconSize: [4, 4]
                  }
                };
              }
              if (_this.mode === 'subtract') {
                return {
                  color: '#FF0000',
                  width: 3
                };
              }
            };
          })(this)
        },
        toolbars: [
          {
            rows: [
              [
                {
                  name: 'draw-poly-add',
                  html: '<i class="drawicon-poly-green"></i>',
                  toggle: true
                }, {
                  name: 'draw-poly-sub',
                  html: '<i class="drawicon-poly-red"></i>',
                  toggle: true
                }
              ], [
                {
                  name: 'draw-rect-add',
                  html: '<i class="drawicon-rect-green"></i>',
                  toggle: true
                }, {
                  name: 'draw-rect-sub',
                  html: '<i class="drawicon-rect-red"></i>',
                  toggle: true
                }
              ], [
                {
                  name: 'draw-circle-add',
                  html: '<i class="drawicon-circle-green"></i>',
                  toggle: true
                }, {
                  name: 'draw-circle-sub',
                  html: '<i class="drawicon-circle-red"></i>',
                  toggle: true
                }
              ]
            ]
          }, {
            style: {
              width: '60px'
            },
            rows: [
              [
                {
                  name: 'draw-undo',
                  html: '<span><i class="fa fa-reply"></i> Undo </span>',
                  toggle: false,
                  style: {
                    width: '61px',
                    'text-decoration': 'none'
                  }
                }
              ]
            ]
          }
        ]
      };
    };

    MfDraw.prototype.onAdd = function(map) {
      var container;
      if (this.map == null) {
        this.map = map;
      }
      this.mode = null;
      this.current_tool = null;
      container = MfDraw.__super__.onAdd.call(this, map);
      this.clipping_transforms = [];
      this.addTransform(this._mergeNewShape);
      this.addCallback('*', this._anyButtonPressed);
      this.addCallback('draw-poly-sub,draw-rect-sub,draw-circle-sub,draw-poly-add,draw-rect-add,draw-circle-add', this._setReenable);
      this.addCallback('draw-poly-sub,draw-rect-sub,draw-circle-sub', this._subtractiveButtonPressed);
      this.addCallback('draw-poly-add,draw-rect-add,draw-circle-add', this._additiveButtonPressed);
      this.addCallback('draw-poly-add,draw-poly-sub', this._drawPolygon);
      this.addCallback('draw-rect-add,draw-rect-sub', this._drawRectangle);
      this.addCallback('draw-circle-add,draw-circle-sub', this._drawCircle);
      this.addCallback('draw-undo', this._undoPressed);
      this.map.on('draw:created', this._handleDrawComplete);
      this.on('mfdraw:shape-added', (function(_this) {
        return function() {
          if (_this.reenable_onfinish) {
            return _this.getButton(_this.last_pressed).trigger('click');
          }
        };
      })(this));
      return container;
    };

    MfDraw.prototype.deleteZone = function(e) {
      return this.fire('zone:delete');
    };

    MfDraw.prototype.onRemove = function() {
      return this.map.off('draw:created', this._handleDrawComplete);
    };

    MfDraw.prototype.addTransform = function(cb) {
      return this.clipping_transforms.push(cb);
    };

    MfDraw.prototype.removeTransform = function(cb) {
      return _.remove(this.clipping_transforms, cb);
    };

    MfDraw.prototype.setLayer = function(layer) {
      return this.layer = layer;
    };

    MfDraw.prototype._undoPressed = function() {
      if (this.current_tool) {
        this.current_tool.disable();
      }
      return this.fire('mfdraw:undo');
    };

    MfDraw.prototype._anyButtonPressed = function(e, name) {
      var ref, ref1, ref2, ref3;
      this.reenable_onfinish = false;
      this.last_pressed = name;
      if ((ref = this.current_tool) != null) {
        ref.active = false;
      }
      if ((ref1 = this.current_tool) != null) {
        if ((ref2 = ref1.h) != null) {
          if (typeof ref2.disable === "function") {
            ref2.disable();
          }
        }
      }
      if ((ref3 = this.current_tool) != null) {
        if (typeof ref3.disable === "function") {
          ref3.disable();
        }
      }
      return this.fire('mfdraw:tool-selected');
    };

    MfDraw.prototype._setReenable = function() {
      return this.reenable_onfinish = true;
    };

    MfDraw.prototype._handleDrawComplete = function(e) {
      var cb, combined, i, layer, len, ref, results, type;
      type = e.layerType;
      layer = e.layer;
      combined = null;
      this.layer_operation = this.mode;
      if (type === 'circle') {
        layer = new L.PolyCircle(layer.getLatLng(), layer.getRadius(), {
          nodes: 20
        });
        layer = layer.getPoly();
      }
      if (turf.area(layer.toGeoJSON()) < 0.1) {
        this.getButton(this.last_pressed).trigger('click');
        return;
      }
      ref = this.clipping_transforms;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        cb = ref[i];
        results.push(combined = cb(type, layer, combined, this.layer));
      }
      return results;
    };

    MfDraw.prototype._finishDrawing = function(combined, cb, update_undo) {
      if (cb == null) {
        cb = false;
      }
      if (update_undo == null) {
        update_undo = true;
      }
      if (this.checkNetChange(combined)) {
        if (this.reenable_onfinish) {
          this.getButton(this.last_pressed).trigger('click');
        }
        return;
      }
      if (update_undo) {
        this.fire('mfdraw:undo-update', {
          previous: this.layer.toGeoJSON()
        });
      }
      this.layer.clearLayers();
      this.addGeometryToLayer(combined);
      this.fire('mfdraw:shape-added');
      if (cb !== false) {
        return cb();
      }
    };

    MfDraw.prototype.addGeometryToLayer = function(geometry) {
      var coordinate;
      if (geometry.features) {
        geometry = geometry.features;
      } else if (geometry.geometry.type === 'MultiPolygon') {
        geometry = (function() {
          var i, len, ref, results;
          ref = geometry.geometry.coordinates;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            coordinate = ref[i];
            results.push(turf.polygon(coordinate));
          }
          return results;
        })();
      } else {
        geometry = [geometry];
      }
      return L.geoJson({
        type: "FeatureCollection",
        features: geometry
      }).eachLayer((function(_this) {
        return function(l) {
          var ref, ref1, ref2;
          l.setStyle((ref = (ref1 = _this.options) != null ? (ref2 = ref1.finished) != null ? ref2.style : void 0 : void 0) != null ? ref : {});
          return _this.layer.addLayer(l);
        };
      })(this));
    };

    MfDraw.prototype._mergeNewShape = function(type, layer, combined, previous_shapes) {
      var l, poly;
      if ((previous_shapes != null ? typeof previous_shapes.getLayers === "function" ? previous_shapes.getLayers().length : void 0 : void 0) > 0) {
        poly = this._getCurrentAsGeojson();
        if (this.mode === 'add') {
          l = layer.toGeoJSON();
          l.properties = {};
          poly.properties = {};
          combined = turf.union(poly, l);
        } else if (this.mode === 'subtract') {
          combined = turf.difference(poly, layer.toGeoJSON());
          if (!combined) {
            this.fire('mfdraw:remove-all');
          }
        }
      } else {
        combined = layer != null ? typeof layer.toGeoJSON === "function" ? layer.toGeoJSON() : void 0 : void 0;
      }
      if (!combined) {
        this._setPgisParams(poly, layer != null ? typeof layer.toGeoJSON === "function" ? layer.toGeoJSON() : void 0 : void 0, this.mode);
        return null;
      }
      this._setPgisParams(combined, null);
      return combined;
    };

    MfDraw.prototype._setPgisParams = function(a, b, c) {
      if (c == null) {
        c = 'union';
      }
      this.layer_one = a;
      this.layer_two = b;
      return this.layer_operation = c;
    };

    MfDraw.prototype._getPgisParams = function() {
      return {
        layer_one: this.layer_one,
        layer_two: this.layer_two,
        operation: this.layer_operation
      };
    };

    MfDraw.prototype._pgis = function(operation, cb) {
      if (cb == null) {
        cb = false;
      }
      if (!cb) {
        return this.fire("pgis:" + operation);
      } else {
        return this.fire("pgis:" + operation, {
          cb: cb
        });
      }
    };

    MfDraw.prototype._subtractiveButtonPressed = function(e, name) {
      this.mode = 'subtract';
      name = name.replace('draw-', 'draw:');
      return this.fire(name);
    };

    MfDraw.prototype._additiveButtonPressed = function(e, name) {
      this.mode = 'add';
      name = name.replace('draw-', 'draw:');
      return this.fire(name);
    };

    MfDraw.prototype._drawRectangle = function() {
      var ref, ref1;
      $('#map_canvas').addClass('leaflet-pane');
      this.current_tool = new L.Draw.CustomRectangle(this.map, {
        shapeOptions: (ref = (ref1 = this.options.colors) != null ? typeof ref1.style === "function" ? ref1.style(this.mode) : void 0 : void 0) != null ? ref : {}
      });
      this.current_tool.options.metric = App.is_metric;
      return this.current_tool.enable();
    };

    MfDraw.prototype._drawPolygon = function() {
      var defaultClasses, handler, ref, self;
      self = this;
      this.disableTooltipButton(this.finishButton);
      this.disableTooltipButton(this.deletePointButton);
      handler = new L.Draw.NewPoly(App.map, {
        allowIntersection: false,
        shapeOptions: (ref = this.options.colors.style(this.mode)) != null ? ref : {}
      });
      handler.options.icon.options.iconSize.x = 16;
      handler.options.icon.options.iconSize.y = 16;
      defaultClasses = 'leaflet-marker-icon leaflet-div-icon leaflet-editing-icon leaflet-zoom-animated leaflet-clickable';
      handler.options.icon.options.className = 'leaflet-marker-icon custom-marker leaflet-editing-icon leaflet-zoom-animated leaflet-clickable';
      $('.leaflet-marker-pane').css('cursor', 'crosshair');
      handler._onTouch = function(e) {
        if (e.originalEvent.target.className.indexOf('leaflet-control-pan') > -1) {

        } else {
          return L.Draw.Polygon.prototype._onTouch.call(this, e);
        }
      };
      App.map.on(L.Draw.Event.DRAWVERTEX, (function(_this) {
        return function(one) {
          var ref1, ref2, ref3;
          if (((ref1 = _this.current_tool.h) != null ? (ref2 = ref1._markers) != null ? ref2.length : void 0 : void 0) > 0) {
            _this.current_tool.h.options.icon.options.iconSize.x = 8;
            _this.current_tool.h.options.icon.options.iconSize.y = 8;
            _this.current_tool.h.options.icon.options.className = defaultClasses;
            _this.enableTooltipButton(_this.deletePointButton);
            _this.fire('mfdraw:polygon-tool-active');
            if (((ref3 = _this.current_tool.h._markers) != null ? ref3.length : void 0) >= 3) {
              return _this.enableTooltipButton(_this.finishButton);
            }
          }
        };
      })(this));
      this.current_tool = {
        h: handler,
        disable: function() {
          this.h.disable();
          App.map.off('mousedown');
          App.map.off(L.Draw.Event.DRAWVERTEX);
          return self.fire('mfdraw:polygon-tool-inactive');
        }
      };
      return handler.enable();
    };

    MfDraw.prototype._drawCircle = function() {
      var ref;
      this.current_tool = new L.Draw.BetterCircle(App.map, {
        shapeOptions: (ref = this.options.colors.style(this.mode)) != null ? ref : {}
      });
      this.current_tool.options.units = App.is_metric ? 'metric' : 'english';
      return this.current_tool.enable();
    };

    MfDraw.prototype._selectPressed = function() {
      return this.layer.on('click', (function(_this) {
        return function(e) {
          return _this._polySelected(e);
        };
      })(this));
    };

    MfDraw.prototype._polySelected = function(e) {
      var cb, handler, ref, self;
      this.setStyle();
      if (e.target !== this.layer) {
        this.fire('zone:select', {
          layer: e.target
        });
      }
      if (((ref = this.current_tool) != null ? ref.active : void 0) === true) {
        return;
      }
      self = this;
      cb = (function(_this) {
        return function() {
          return _this._selectPressed();
        };
      })(this);
      this.current_tool = {
        h: null,
        disable: (function(_this) {
          return function(from_edit) {
            if (from_edit == null) {
              from_edit = false;
            }
            if (!from_edit) {
              _this._setPgisParams(_this.layer.toGeoJSON(), null);
              _this._pgis('edit', cb);
              _this.fire('draw:shape-added');
            }
            _this.layer.off('click', _this._polySelected);
            return _this.current_tool.finish();
          };
        })(this),
        finish: function() {
          var ref1;
          if ((ref1 = this.h) != null) {
            if (typeof ref1.disable === "function") {
              ref1.disable();
            }
          }
          return self.layer.off('click', this._polySelected);
        },
        active: true
      };
      handler = new L.Edit.PolyWithHoles(e.layer, {
        color: this.options.draw.color
      });
      handler.enable();
      this.current_tool.h = handler;
      return handler.on('geometry-valid', (function(_this) {
        return function(param) {
          var callback, ref1, ref2;
          callback = function() {
            _this.current_tool.active = false;
            _this._setPgisParams(param.layer.toGeoJSON(), null);
            _this._pgis('edit', cb);
            _this.fire('draw:shape-added');
            return _this.current_tool.disable(true);
          };
          return (ref1 = _this.current_tool) != null ? (ref2 = ref1.h) != null ? typeof ref2.removeHooks === "function" ? ref2.removeHooks(callback) : void 0 : void 0 : void 0;
        };
      })(this));
    };

    MfDraw.prototype._getCurrentAsGeojson = function() {
      var poly;
      poly = {
        'type': 'Feature',
        'geometry': {
          'type': 'MultiPolygon',
          'coordinates': []
        }
      };
      this.layer.eachLayer((function(_this) {
        return function(l) {
          var coords, gj, i, len, p, results;
          gj = l.toGeoJSON().geometry;
          coords = gj.coordinates;
          if (gj.type === 'MultiPolygon') {
            results = [];
            for (i = 0, len = coords.length; i < len; i++) {
              p = coords[i];
              results.push(poly.geometry.coordinates.push(p));
            }
            return results;
          } else {
            return poly.geometry.coordinates.push(coords);
          }
        };
      })(this));
      return poly;
    };

    MfDraw.prototype.checkNetChange = function(layer) {
      if (layer) {
        return turf.area(layer) === turf.area(this.layer.toGeoJSON());
      }
    };

    MfDraw.prototype.getAreas = function(pusharray, start, polynum, units) {
      if (pusharray == null) {
        pusharray = [];
      }
      if (polynum == null) {
        polynum = 1;
      }
      if (units == null) {
        units = 'ac';
      }
      if (start == null) {
        start = this.layer;
      }
      start.eachLayer((function(_this) {
        return function(layer) {
          var coords, geojson, i, len, ref;
          geojson = layer.toGeoJSON();
          if (geojson.geometry.type === 'MultiPolygon') {
            ref = geojson.geometry.coordinates;
            for (i = 0, len = ref.length; i < len; i++) {
              coords = ref[i];
              pusharray = _this.addPolygon(turf.polygon(coords), pusharray, units, polynum, start, layer);
            }
          } else {
            pusharray = _this.addPolygon(geojson, pusharray, units, polynum, start, layer);
          }
          return polynum++;
        };
      })(this));
      return pusharray;
    };

    MfDraw.prototype.addPolygon = function(geojson, pusharray, units, polynum, start, layer) {
      var area, ft, i, ind, len, newpoly, ref, ring;
      ref = geojson.geometry.coordinates;
      for (ind = i = 0, len = ref.length; i < len; ind = ++i) {
        ring = ref[ind];
        ft = turf.polygon([ring]);
        if (units === 'ac') {
          area = turf.area(ft) * 0.000247105;
        } else if (units === 'ha') {
          area = turf.area(ft) * 0.0001;
        }
        if (area > 0.000001) {
          newpoly = {
            number: ind === 0 ? polynum : ind,
            area: area,
            parent_layer: start,
            layer: layer,
            type: ind === 0 ? 'area' : 'hole'
          };
          pusharray.push(newpoly);
        }
      }
      return pusharray;
    };

    return MfDraw;

  })(L.Control.MfButtonGrid);

}).call(this);
